import { computed, ref } from "vue";
import { useStore } from '@/states/index'

export const isDemoModeDialogOpen = ref(false);
let pendingResolvers = [];
const options = ref({});

export const useDemoMode = () => {
  const store = useStore()

  const isDemoMode = computed(() => store.isDemoMode);

  const onOpenDemoModePane = () => {
    isDemoModeDialogOpen.value = true;

    return new Promise((resolve) => {
      pendingResolvers.push(resolve);
    })
  }

  const handleResponse = (answer) => {
    isDemoModeDialogOpen.value = false;
    pendingResolvers.forEach((resolve) => resolve(answer))
    pendingResolvers = [];
    setTimeout(() => {
      options.value = {};
    }, 200);
  }

  return {
    isDemoMode,
    isDemoModeDialogOpen,
    onOpenDemoModePane,
    handleResponse
  }
}

